import { motion } from "framer-motion";
import { fadeUp, revealOnce } from "./motion";
import "./SectionHeading.css";

export default function SectionHeading({ eyebrow, title, subtitle, align = "center" }) {
  return (
    <motion.header
      className={`section-head section-head--${align}`}
      variants={fadeUp}
      {...revealOnce}
    >
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2 className="section-head__title">{title}</h2>
      {subtitle && <p className="section-head__subtitle">{subtitle}</p>}
    </motion.header>
  );
}
